import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../store';
import { toggle } from '../../../store/popups/legend';
import { getLegendData, ILegendItem } from '../../../utils/legend';
import { getOfferType } from '../../../utils/offer_type';
import { ILegendProps, Legend } from './index';

type TStoreProps = Pick<ILegendProps, 'legendData'>;
type TDispatchProps = Pick<ILegendProps, 'openModal'>;

function mapStateToProps(state: IState): TStoreProps {
  let legendData: ILegendItem[] = [];
  const offerType = getOfferType(state.offerData.offer);

  if (state.mapSimilar) {
    legendData = getLegendData(state.mapSimilar.data.points, offerType);
  }

  return { legendData };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): TDispatchProps {
  return {
    openModal: () => dispatch(toggle(true)),
  };
}

export const LegendContainer = connect<TStoreProps, TDispatchProps, {}>(mapStateToProps, mapDispatchToProps)(Legend);
